import axios from 'axios';
import { appApiUrl } from './appApiOrigin';

const SESSION_CACHE_MS = 45_000;
const SESSION_STORAGE_KEY = 'bahlus_app_session_until';

let cachedOk = false;
let cachedUntil = 0;
let inflight = null;

function readSessionStorageExpiry() {
  try {
    const exp = Number(sessionStorage.getItem(SESSION_STORAGE_KEY) || 0);
    return Number.isFinite(exp) && exp > Date.now() ? exp : 0;
  } catch {
    return 0;
  }
}

function writeSessionStorageExpiry(until) {
  try {
    if (until > Date.now()) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, String(until));
    } else {
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function invalidateSessionCache() {
  cachedOk = false;
  cachedUntil = 0;
  inflight = null;
  writeSessionStorageExpiry(0);
}

export function peekSessionCache() {
  const now = Date.now();
  if (cachedOk && now < cachedUntil) return true;
  const storedUntil = readSessionStorageExpiry();
  if (storedUntil > now) {
    cachedOk = true;
    cachedUntil = storedUntil;
    return true;
  }
  return false;
}

/** Call after a successful profile load or sign-in so product switches skip re-auth flash. */
export function markSessionValid() {
  const until = Date.now() + SESSION_CACHE_MS;
  cachedOk = true;
  cachedUntil = until;
  writeSessionStorageExpiry(until);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('bahlus-session-validated'));
  }
}

/** Shared validate-session check (deduped) for route guards and SSO navigation. */
export async function checkAppSession({ force = false } = {}) {
  const now = Date.now();
  if (!force && cachedOk && now < cachedUntil) {
    return true;
  }

  if (!force && inflight) {
    return inflight;
  }

  inflight = axios
    .post(appApiUrl('/api/validate-session'), {}, { withCredentials: true, timeout: 20_000 })
    .then((res) => {
      const ok = res.data?.success === true;
      cachedOk = ok;
      cachedUntil = ok ? Date.now() + SESSION_CACHE_MS : 0;
      return ok;
    })
    .catch(() => {
      cachedOk = false;
      cachedUntil = 0;
      return false;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}
